!function($, window) {
    const $win = $(window), $doc = $(document), $body = $(document.body);
    let interval1, interval2, teamCardTimeout, overrideInterval1, overrideInterval2;
    const isMobile = () => $win.outerWidth() <= 767;
    function getRandomNumber(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    }
    function showGlitchForMedia() {
        const $glitchParents = $(".js-glitch-parent");
        $glitchParents.length && $glitchParents.each((function() {
            !function setClassNameOnRandomElement($elements) {
                interval1 = setInterval((() => {
                    const randomNumber = getRandomNumber(0, $elements.length);
                    $elements.eq(randomNumber).addClass("has-glitched");
                }), 600), interval2 = setInterval((() => {
                    const randomNumber = getRandomNumber(0, $elements.length);
                    $elements.eq(randomNumber).removeClass("has-glitched");
                }), 300);
            }($(this).find(".js-glitch-element"));
        }));
    }
    if ($(".js-glitch-element").on("mouseenter", (function() {
        $("body").hasClass("body--code") && ($(this).addClass("override-glitch"), overrideInterval1 = setInterval((() => {
            $(this).addClass("override-glitch-on");
        }), 500), overrideInterval2 = setInterval((() => {
            $(this).removeClass("override-glitch-on");
        }), 300));
    })).on("mouseleave", (function() {
        clearInterval(overrideInterval1), clearInterval(overrideInterval2), $(this).removeClass("override-glitch").removeClass("override-glitch-on");
    })), $doc.on("efr_during_code_mode_change", ((e, state) => {
        "code" === state ? showGlitchForMedia() : (clearInterval(interval1), clearInterval(interval2), 
        $(".js-glitch-element").removeClass("has-glitched"));
        const $ascii_pre = $(".ascii-pre"), has_booted = $ascii_pre.hasClass("booted");
        "code" === state ? has_booted ? $ascii_pre.removeClass("hidden") : (window.ertdfgcvb.boot({
            word: ""
        }), $ascii_pre.addClass("booted")) : $ascii_pre.addClass("hidden");
    })), $("body").hasClass("body--code")) {
        const $ascii_pre = $(".ascii-pre");
        $ascii_pre.hasClass("booted") ? $ascii_pre.removeClass("hidden") : (window.ertdfgcvb.boot({
            word: ""
        }), $ascii_pre.addClass("booted"));
    }
    function flipCard(elemID) {
        void 0 !== elemID && setTimeout((function() {
            $("#" + elemID.replace("#", "")).find(".card-team-large__container")[0].animation.play();
        }), 600);
    }
    function unflipCard(elemID) {
        if (void 0 !== elemID) {
            $("#" + elemID.replace("#", "")).find(".card-team-large__container")[0].animation.reverse();
        }
    }
    $(".js-handle-card-submit").on("click", (function(e) {
        e.preventDefault(), $(this).closest(".card-team-large").find("form").find("input[type='submit']").trigger("click");
    })), $(".js-close-popup").on("click", (function(e) {
        e.preventDefault();
        const $this = $(this), $target = $($this.attr("href"));
        let timeout = 0;
        $win.width() >= 768 && (timeout = 500), $("body").hasClass("is-safari") && $target.hasClass("card-team-large--secondary") && $target.children(".card-team-large__container").scrollTop(0), 
        unflipCard($target.attr("id")), setTimeout((function() {
            $this.closest("section").add($target).removeClass("large-card-is-visible"), $('.js-toggle-more[aria-expanded="true"]').attr("aria-expanded", "false"), 
            $body.removeClass("popup-open"), isMobile() && $body.removeClass("not-scrollable");
        }), timeout);
    })), $(".js-toggle-more").on("click", (function(e) {
        e.preventDefault();
        const $this = $(this), $target = $("#" + $this.attr("aria-controls")), popupIsOpen = $this.closest("section").hasClass("large-card-is-visible");
        if (isMobile() || $("html, body").stop().animate({
            scrollTop: $this.closest("section").offset().top - $(".header").outerHeight()
        }, 400), popupIsOpen) {
            null != teamCardTimeout && clearTimeout(teamCardTimeout);
            let $currentOpenCard = $this.closest("section").find(".card-team-large.large-card-is-visible");
            if ($currentOpenCard.attr("id") == $this.attr("aria-controls")) return void $(".card-team-large.large-card-is-visible .js-close-popup").trigger("click");
            unflipCard($currentOpenCard.attr("id")), $currentOpenCard.removeClass("large-card-is-visible"), 
            $('.js-toggle-more[aria-expanded="true"]').attr("aria-expanded", "false"), teamCardTimeout = setTimeout((() => {
                $this.closest("section").addClass("large-card-is-visible"), $target.addClass("large-card-is-visible"), 
                $this.attr("aria-expanded", "true"), flipCard($target.attr("id"));
            }), 400);
        } else {
            let $thisSection = $this.closest("section");
            $thisSection.find(".large-card-is-visible").removeClass("large-card-is-visible"), 
            null != teamCardTimeout && clearTimeout(teamCardTimeout), $thisSection.add($target).addClass("large-card-is-visible"), 
            flipCard($target.attr("id")), $this.attr("aria-expanded", "true");
        }
        window.dataLayer = window.dataLayer || [], dataLayer.push({
            event: "team_member_click",
            team_member_name: $this.data("person-name")
        }), $body.addClass("popup-open"), isMobile() && $body.addClass("not-scrollable");
    }));
    let $cardArrow = $("a.card-team-large__arrow");
    $cardArrow.on("click", (function(e) {
        e.preventDefault();
        let cardTeamLargeContainerHeight = $(".card-team-large--secondary .card-team-large__container").outerHeight(), maxCardTeamLargeSecondary = $(".card-team-large--secondary .card-team-large__container .card__back").outerHeight();
        maxCardTeamLargeSecondary > cardTeamLargeContainerHeight && $(".card-team-large--secondary .card-team-large__container").stop().animate({
            scrollTop: maxCardTeamLargeSecondary - cardTeamLargeContainerHeight + 10
        }, 400);
    }));
    const $teamFormContainer = $(".card-team-large--secondary .card-team-large__container"), $teamFormScrollEnd = $(".card-team-large--secondary-scroll-end");
    let atBottom = !1, lastScrollTop = 0;
    function hideShowCardArrow() {
        let containerBack = $(".card-team__apply")[0].scrollHeight;
        $(".card-team-large--secondary").outerHeight() >= containerBack ? $cardArrow.addClass("hide-arrow") : $cardArrow.removeClass("hide-arrow");
    }
    new IntersectionObserver((entries => {
        entries.forEach((entry => {
            entry.isIntersecting && ($cardArrow.addClass("hide-arrow"), atBottom = !0);
        }));
    }), {
        root: $teamFormContainer[0],
        threshold: 1
    }).observe($teamFormScrollEnd[0]), $teamFormContainer.on("scroll", (function() {
        const scrollTop = $teamFormContainer.scrollTop();
        atBottom && scrollTop + 5 < lastScrollTop && (atBottom = !1, $cardArrow.removeClass("hide-arrow")), 
        lastScrollTop = scrollTop;
    })), hideShowCardArrow(), $body.on("click", (function(e) {
        const $target = $(e.target);
        $target.is("button") || $target.closest("button").length || $target.is("a") || $target.closest("a").length || $target.hasClass("card-team-large") || $target.closest(".card-team-large").length || $target.hasClass("card-team") || $target.closest(".card-team").length || $(".card-team-large.large-card-is-visible .js-close-popup").trigger("click");
    })), $win.on("load", (function() {
        !function setupCardFlips() {
            TweenMax.set($(".card-team-large .card__back"), {
                rotationY: -180
            }), $(".card-team-large .card-team-large__container").each((function(i, elem) {
                var frontCard = $(this).children(".card__front"), backCard = $(this).children(".card__back"), tl = ($(this).parent().attr("id"), 
                new TimelineMax({
                    paused: !0
                }));
                tl.to(frontCard, .4, {
                    rotationY: 180
                }).to(backCard, .4, {
                    rotationY: 0
                }, 0), elem.animation = tl;
            }));
        }(), $("body").hasClass("body--code") && showGlitchForMedia();
    })), $win.on("resize", (function() {
        hideShowCardArrow();
    }));
}(jQuery, window, document);